import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { filter, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ActivatedRoute } from '@angular/router';
import { CampaignService } from '../campaign.service';
import { CommonModule, CurrencyPipe} from '@angular/common';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
	private ngUnsubscribe = new Subject<void>();
	@ViewChild('tabhead') tabhead: ElementRef;
	market_str="$1,000,000.00";
 	market_num=1000000;
	market={
		original:0,
		new:0,
		increase:0,
		incremental:0,
		scale_max:0,
		scale_step:0
	}

	stock_str="10%";
	stock_num=.1;
	demo_data: any | [];
	best_data: any | [];
	trust_data: any | [];
	attr_data: any | [];
	current_behaviors: any | [];
	current_attributes: any |[];
	behavior_data: any | [];
	industry_visible=false;
	sector_visible=false;
	signal="Humanity";
	demographic='Ethnicity';
	current_demo: any |[];
	industry='';
	sector='';
	category='';
	industries: any|[];
	sectors:any|[];
	categories: any|[];
	demographics: any|[];
	openSelect=false;
	select_open_industry=false;
	select_open_sector=false;
	select_open_category=false;
	current_industries=[];
	current_sectors=[];
	current_categories=[];
	
	temp_arr={
		responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
	};
	result_arr={
		composite:0,transparency:0,reliability:0,capability:0,humanity:0,
		offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
	};
	industry_scores={
		composite:0,transparency:0,reliability:0,capability:0,humanity:0,offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0	
	};
	sector_scores={
		composite:0,transparency:0,reliability:0,capability:0,humanity:0,offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
	};
	current_scores={
		composite:0,transparency:0,reliability:0,capability:0,humanity:0,offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
	};


   constructor(private route: ActivatedRoute, public CS: CampaignService, private currencyPipe : CurrencyPipe) { }

  ngOnInit(): void {
	  this.current_behaviors=this.CS.totalObj;
	  this.CS.current_page=this.route.snapshot.url[0].path;
	  //this.CS.pullScores().pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => { 
		  this.trust_data=this.CS.trustObj;
		  this.setIndustries();
		 // this.industry_scores=this.generateBenchmarks('industry');
		  //this.current_scores==this.generateBenchmarks('industry');
		  this.current_scores=this.generateBenchmarksNew();
		  this.generateMarketCap();
		  //console.log('Scores is', this.trust_data);
		  
	 // });
	  //this.CS.pullBest().pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => { 
		  this.best_data=this.CS.bestObj;
		  this.industry_scores=this.generateBestScoresNew();
		  //console.log('bests is', this.industry_scores);
		  //console.log('bestcurrents is also', this.current_scores);
		  
	 // });
																	   
	  //this.CS.pullDemos().pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => { 
		  this.demo_data=this.CS.demoObj;//data;
		  this.setDemos();
		  //console.log('Demos is', this.demo_data);
		  this.selectDemo();
	 // });
	 // this.CS.pullBehaviors().pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => { 
		  this.behavior_data=this.CS.behaviorObj;//data;
		  this.current_behaviors=this.CS.processBehaviors(this.behavior_data);
		  //console.log('Behaviors is', this.behavior_data);
		  //console.log('current is', this.current_behaviors);
	 // });
	 // this.CS.pullAttrs().pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => { 
		  this.attr_data=this.CS.attrObj;//data;
		  //console.log('Attributes is', this.attr_data);
	 // });
  }
	
   ngOnDestroy(){
	this.ngUnsubscribe.next();
	this.ngUnsubscribe.complete();
  }
	figureIt(metric,factor){
		var x=this.current_behaviors[metric+factor+'Agree'];
		var y=this.current_behaviors[metric+factor+'Disagree'];
		var ttl=(x/y)*10; ////console.log(ttl);
		ttl=Math.round(ttl);////console.log(ttl);
		ttl=ttl/10;////console.log(ttl);
		return ttl;		
	}
	graphIt(metric,factor,val){
		var x=this.current_behaviors[metric+factor+val];
		var y=this.current_behaviors[metric+'Response'];
		var score=Math.round(x/y*100);
		return score;
	}
	signalUpdate(){
		//get latest set of scores
		//pull scores for signal
		//set current behaviors
	}
	toggleTab(newtab){
		this.CS.current_tab=newtab;
		this.scrollTo();
	}
	setDemos(){
		var items=[];
		this.demo_data.forEach(function(obj){
		  if(items.indexOf(obj.demo)<0){
			  items.push(obj.demo);
		  }
	  });
		this.demographics=items.sort();
		////console.log('demos',items);
	}
	selectDemo(){
		this.current_demo=[];
		//console.log('demoooo is', this.demo_data);
		var that=this;
		var respondents=0;
		var responses=0;
		var items=[];
		var cols=[];
		var brk=0;
		var agree=0;
		var disagree=0;
		var surveyed=0;
		// industry/scetor/caregory
	
		//demo
		//for each grouping
		this.demo_data.forEach(function(obj){
			if(obj.demo==that.demographic){
				if(obj.industry==that.industry||that.industry==''){
					if(obj.brands_grouping==that.sector||that.sector==''){
						if(obj.brands_category==that.category||that.category==''){
							respondents+=Number(obj.responses);//get total responses
							if(cols.indexOf(obj.grouping)<0){
								cols.push(obj.grouping);
							}
						}			
					}
				}	
			}	
		});
		cols.forEach(function(obj2){
			responses=0;
			brk=0;
			agree=0;
			disagree=0;
			surveyed=0;
			that.demo_data.forEach(function(obj){
				if(obj.demo==that.demographic && obj.grouping==obj2){
					if(obj.industry==that.industry||that.industry==''){
						if(obj.brands_grouping==that.sector||that.sector==''){
							if(obj.brands_category==that.category||that.category==''){
								responses+=Number(obj.responses);
								agree+=Number(obj.CompositeAgree);
								disagree+=Number(obj.CompositeDisagree);
							}
						}
					}
				}		
			});
			brk=Math.round((agree-disagree)/responses*100);
			surveyed=Math.round(responses/respondents*100);
			items.push({"column":obj2, "breakout":brk,"surveyed":surveyed});
			
		});
		this.current_demo=items;
		//console.log('demo',items);
	}
	setIndustries(){
		var items=[];
		this.trust_data.forEach(function(obj){
		  if(items.indexOf(obj.industry)<0){
			  items.push(obj.industry);
			  //console.log(obj.industry);
		  }
	  	});
		this.industries=items;
		//console.log('ind',items);
	
	}
	selectIndustry(){
		this.industry_scores=this.generateBenchmarks('industry');
		this.current_scores=this.industry_scores;
		this.current_behaviors=this.generateBehaviors('industry');
		this.current_attributes=this.generateAttributes('industry');
		this.generateMarketCap();
		this.setSectors();
		this.selectDemo();
	}
	setSectors(){
		var items=[];
		var that=this;
		this.trust_data.forEach(function(obj){
		  if(obj.industry==that.industry){
			  if(items.indexOf(obj.brands_grouping)<0){
				  items.push(obj.brands_grouping);
			  }
		  }
	  });
		this.sectors=items;
		//console.log('sectors',items);
	}
	setCategories(sector){
		this.category="";
		this.clearCalcScores();

		if(sector!==""){
			var items=[];
			////console.log('sect',sector);
			this.trust_data.forEach(function(obj){
				if(obj.brands_grouping==sector){
					if(items.indexOf(obj.brands_category)<0){
						items.push(obj.brands_category);
					}	
				}
		  	});
			this.categories=items;
			this.sector_scores=this.generateBenchmarks('sector');
			this.current_behaviors=this.generateBehaviors('sector');
			this.current_scores=this.sector_scores;
			this.current_attributes=this.generateAttributes('sector');
		 }else{
			 this.sector_scores={composite:0,transparency:0,reliability:0,capability:0,humanity:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0,offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0};
			 this.sector_visible=false;
			 this.current_scores=this.generateBenchmarks('industry');
			this.current_behaviors=this.generateBehaviors('industry');
			 this.current_attributes=this.generateAttributes('industry');
		 }
		
	  	this.generateMarketCap();
		this.selectDemo();
		////console.log(this.categories);
	}
	setCategoryScores(){
		if(this.category==""){
			this.clearCalcScores();
			this.current_scores=this.generateBenchmarks('sector');
			this.current_behaviors=this.generateBehaviors('sector');
		}else{
			this.current_scores=this.generateBenchmarks('category');
			this.current_behaviors=this.generateBehaviors('category');			
		}
	  	this.generateMarketCap();
		this.selectDemo();
	}
	
	clearCalcScores(){
		this.result_arr={
			composite:0,transparency:0,reliability:0,capability:0,humanity:0,
			offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
		};
		this.temp_arr={
			responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
		};
		this.current_scores={
			composite:0,transparency:0,reliability:0,capability:0,humanity:0,
			offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
		};
	}
	
	clearBestCalcScores(){
		this.result_arr={
			composite:0,transparency:0,reliability:0,capability:0,humanity:0,
			offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
		};
		this.temp_arr={
			responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
		};
		this.industry_scores={
			composite:0,transparency:0,reliability:0,capability:0,humanity:0,
			offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0
		};
		
	}

	calculateArr(arr,obj){
		arr.responses+=Number(obj.responses);
		arr.hd+=Number(obj.HumanityDisagree);
		arr.ha+=Number(obj.HumanityAgree);
		arr.td+=Number(obj.TransparencyDisagree);
		arr.ta+=Number(obj.TransparencyAgree);
		arr.cd+=Number(obj.CapabilityDisagree);
		arr.ca+=Number(obj.CapabilityAgree);
		arr.rd+=Number(obj.ReliabilityDisagree);
		arr.ra+=Number(obj.ReliabilityAgree);
		arr.xd+=Number(obj.CompositeDisagree);
		arr.xa+=Number(obj.CompositeAgree);
		return arr;
	}
	calculateArrBehavior(arr,obj){
		arr.PurchResponse+=Number(obj.PurchResponse);
		arr.PurchStrongResponse+=Number(obj.PurchStrongResponse);
		arr.AdvResponse+=Number(obj.AdvResponse);
		arr.AdvStrongResponse+=Number(obj.AdvStrongResponse);
		arr.ServiceResponse+=Number(obj.ServiceResponse);
		arr.ServiceStrongResponse+=Number(obj.ServiceStrongResponse);
		arr.PurchHumanityDisagree+=Number(obj.PurchHumanityDisagree);
		arr.PurchHumanityAgree+=Number(obj.PurchHumanityAgree);
		arr.PurchTransparencyDisagree+=Number(obj.PurchTransparencyDisagree);
		arr.PurchTransparencyAgree+=Number(obj.PurchTransparencyAgree);
		arr.PurchCapabilityDisagree+=Number(obj.PurchCapabilityDisagree);
		arr.PurchCapabilityAgree+=Number(obj.PurchCapabilityAgree);
		arr.PurchReliabilityDisagree+=Number(obj.PurchReliabilityDisagree);
		arr.PurchReliabilityAgree+=Number(obj.PurchReliabilityAgree);
		arr.PurchCompositeDisagree+=Number(obj.PurchCompositeDisagree);
		arr.PurchCompositeAgree+=Number(obj.PurchCompositeAgree);
		arr.PurchStrongHumanityDisagree+=Number(obj.PurchStrongHumanityDisagree);
		arr.PurchStrongHumanityAgree+=Number(obj.PurchStrongHumanityAgree);
		arr.PurchStrongTransparencyDisagree+=Number(obj.PurchStrongTransparencyDisagree);
		arr.PurchStrongTransparencyAgree+=Number(obj.PurchStrongTransparencyAgree);
		arr.PurchStrongCapabilityDisagree+=Number(obj.PurchStrongCapabilityDisagree);
		arr.PurchStrongCapabilityAgree+=Number(obj.PurchStrongCapabilityAgree);
		arr.PurchStrongReliabilityDisagree+=Number(obj.PurchStrongReliabilityDisagree);
		arr.PurchStrongReliabilityAgree+=Number(obj.PurchStrongReliabilityAgree);
		arr.PurchStrongCompositeDisagree+=Number(obj.PurchStrongCompositeDisagree);
		arr.PurchStrongCompositeAgree+=Number(obj.PurchStrongCompositeAgree);
		arr.AdvHumanityDisagree+=Number(obj.AdvHumanityDisagree);
		arr.AdvHumanityAgree+=Number(obj.AdvHumanityAgree);
		arr.AdvTransparencyDisagree+=Number(obj.AdvTransparencyDisagree);
		arr.AdvTransparencyAgree+=Number(obj.AdvTransparencyAgree);
		arr.AdvCapabilityDisagree+=Number(obj.AdvCapabilityDisagree);
		arr.AdvCapabilityAgree+=Number(obj.AdvCapabilityAgree);
		arr.AdvReliabilityDisagree+=Number(obj.AdvReliabilityDisagree);
		arr.AdvReliabilityAgree+=Number(obj.AdvReliabilityAgree);
		arr.AdvCompositeDisagree+=Number(obj.AdvCompositeDisagree);
		arr.AdvCompositeAgree+=Number(obj.AdvCompositeAgree);
		arr.AdvStrongHumanityDisagree+=Number(obj.AdvStrongHumanityDisagree);
		arr.AdvStrongHumanityAgree+=Number(obj.AdvStrongHumanityAgree);
		arr.AdvStrongTransparencyDisagree+=Number(obj.AdvStrongTransparencyDisagree);
		arr.AdvStrongTransparencyAgree+=Number(obj.AdvStrongTransparencyAgree);
		arr.AdvStrongCapabilityDisagree+=Number(obj.AdvStrongCapabilityDisagree);
		arr.AdvStrongCapabilityAgree+=Number(obj.AdvStrongCapabilityAgree);
		arr.AdvStrongReliabilityDisagree+=Number(obj.AdvStrongReliabilityDisagree);
		arr.AdvStrongReliabilityAgree+=Number(obj.AdvStrongReliabilityAgree);
		arr.AdvStrongCompositeDisagree+=Number(obj.AdvStrongCompositeDisagree);
		arr.AdvStrongCompositeAgree+=Number(obj.AdvStrongCompositeAgree);
		arr.ServiceHumanityDisagree+=Number(obj.ServiceHumanityDisagree);
		arr.ServiceHumanityAgree+=Number(obj.ServiceHumanityAgree);
		arr.ServiceTransparencyDisagree+=Number(obj.ServiceTransparencyDisagree);
		arr.ServiceTransparencyAgree+=Number(obj.ServiceTransparencyAgree);
		arr.ServiceCapabilityDisagree+=Number(obj.ServiceCapabilityDisagree);
		arr.ServiceCapabilityAgree+=Number(obj.ServiceCapabilityAgree);
		arr.ServiceReliabilityDisagree+=Number(obj.ServiceReliabilityDisagree);
		arr.ServiceReliabilityAgree+=Number(obj.ServiceReliabilityAgree);
		arr.ServiceCompositeDisagree+=Number(obj.ServiceCompositeDisagree);
		arr.ServiceCompositeAgree+=Number(obj.ServiceCompositeAgree);
		arr.ServiceStrongHumanityDisagree+=Number(obj.ServiceStrongHumanityDisagree);
		arr.ServiceStrongHumanityAgree+=Number(obj.ServiceStrongHumanityAgree);
		arr.ServiceStrongTransparencyDisagree+=Number(obj.ServiceStrongTransparencyDisagree);
		arr.ServiceStrongTransparencyAgree+=Number(obj.ServiceStrongTransparencyAgree);
		arr.ServiceStrongCapabilityDisagree+=Number(obj.ServiceStrongCapabilityDisagree);
		arr.ServiceStrongCapabilityAgree+=Number(obj.ServiceStrongCapabilityAgree);
		arr.ServiceStrongReliabilityDisagree+=Number(obj.ServiceStrongReliabilityDisagree);
		arr.ServiceStrongReliabilityAgree+=Number(obj.ServiceStrongReliabilityAgree);
		arr.ServiceStrongCompositeDisagree+=Number(obj.ServiceStrongCompositeDisagree);
		arr.ServiceStrongCompositeAgree+=Number(obj.ServiceStrongCompositeAgree);
		return arr;
	}
	
	resetSelected(){
		var that=this;
		//console.log('startsect', this.current_sectors);
		this.trust_data.forEach(function (obj2){
			if(!that.includedItem(obj2.industry, 'current_industries')){
				that.removeItem(obj2.brands_grouping,'current_sectors');				
			}					
		});
		this.trust_data.forEach(function (obj2){
			if(!that.includedItem(obj2.brands_grouping, 'current_sectors')){
				that.removeItem(obj2.brands_category,'current_categories');				
			}
		});
	}
	
	selectDemoNew(){
		this.current_demo=[];
		//console.log('demoooo is', this.demo_data);
		var that=this;
		var respondents=0;
		var responses=0;
		var items=[];
		var cols=[];
		var brk=0;
		var hagree=0;
		var hdisagree=0;
		var tagree=0;
		var tdisagree=0;
		var cagree=0;
		var cdisagree=0;
		var ragree=0;
		var rdisagree=0;
		var surveyed=0;
		var htemp;
		var ttemp;
		var rtemp;
		var ctemp;
		this.demo_data.forEach(function(obj){
			if(obj.demo==that.demographic){
				
				if(that.current_categories.length>0){
					////console.log( 'cat', that.current_categories);
					////console.log( 'objcats', obj.brands_category);
					if(that.current_categories.findIndex((element) => element == obj.brands_category)>-1){
						//console.log('Thiscategory',obj.brands_category, Number(obj.responses));
						respondents+=Number(obj.responses);//get total responses
						if(cols.indexOf(obj.grouping)<0){
							cols.push(obj.grouping);
						}
					}
				}else if(that.current_sectors.length>0){
					if(that.current_sectors.findIndex((element) => element == obj.brands_grouping)>-1){
						//console.log('sectprs',obj.brands_grouping);
						respondents+=Number(obj.responses);//get total responses
						if(cols.indexOf(obj.grouping)<0){
							cols.push(obj.grouping);
						}
					}
				}else if(that.current_industries.length>0){
					if(that.current_industries.findIndex((element) => element == obj.industry)>-1){
						////console.log('insdustry',obj.industry);
						respondents+=Number(obj.responses);//get total responses
						if(cols.indexOf(obj.grouping)<0){
							cols.push(obj.grouping);
						}
					}
				}else if(that.current_industries.length==0){
					respondents+=Number(obj.responses);//get total responses
					if(cols.indexOf(obj.grouping)<0){
						cols.push(obj.grouping);
					}
				}
				
			}	
		});
		cols.forEach(function(obj2){
			responses=0;
			brk=0;
			hagree=0;
			hdisagree=0;
			tagree=0;
			tdisagree=0;
			cagree=0;
			cdisagree=0;
			ragree=0;
			rdisagree=0;
			surveyed=0;
			that.demo_data.forEach(function(obj){
				if(obj.demo==that.demographic && obj.grouping==obj2){
					if(that.current_categories.length>0){
						if(that.current_categories.findIndex((element) => element == obj.brands_category)>-1){
							responses+=Number(obj.responses);
							hagree+=Number(obj.HumanityAgree);
							hdisagree+=Number(obj.HumanityDisagree);
							tagree+=Number(obj.TransparencyAgree);
							tdisagree+=Number(obj.TransparencyDisagree);
							cagree+=Number(obj.CapabilityAgree);
							cdisagree+=Number(obj.CapabilityDisagree);
							ragree+=Number(obj.ReliabilityAgree);
							rdisagree+=Number(obj.ReliabilityDisagree);
						}
					}else if(that.current_sectors.length>0){
						if(that.current_sectors.findIndex((element) => element == obj.brands_grouping)>-1){
							responses+=Number(obj.responses);
							hagree+=Number(obj.HumanityAgree);
							hdisagree+=Number(obj.HumanityDisagree);
							tagree+=Number(obj.TransparencyAgree);
							tdisagree+=Number(obj.TransparencyDisagree);
							cagree+=Number(obj.CapabilityAgree);
							cdisagree+=Number(obj.CapabilityDisagree);
							ragree+=Number(obj.ReliabilityAgree);
							rdisagree+=Number(obj.ReliabilityDisagree);
						}
					}else if(that.current_industries.length>0){
						if(that.current_industries.findIndex((element) => element == obj.industry)>-1){
							responses+=Number(obj.responses);
							hagree+=Number(obj.HumanityAgree);
							hdisagree+=Number(obj.HumanityDisagree);
							tagree+=Number(obj.TransparencyAgree);
							tdisagree+=Number(obj.TransparencyDisagree);
							cagree+=Number(obj.CapabilityAgree);
							cdisagree+=Number(obj.CapabilityDisagree);
							ragree+=Number(obj.ReliabilityAgree);
							rdisagree+=Number(obj.ReliabilityDisagree);
						}
					}else if(that.current_industries.length==0){
						responses+=Number(obj.responses);
						hagree+=Number(obj.HumanityAgree);
						hdisagree+=Number(obj.HumanityDisagree);
						tagree+=Number(obj.TransparencyAgree);
						tdisagree+=Number(obj.TransparencyDisagree);
						cagree+=Number(obj.CapabilityAgree);
						cdisagree+=Number(obj.CapabilityDisagree);
						ragree+=Number(obj.ReliabilityAgree);
						rdisagree+=Number(obj.ReliabilityDisagree);
					}
				}		
			});
			htemp=Math.round((hagree-hdisagree)/responses*100);
			ttemp=Math.round((tagree-tdisagree)/responses*100);
			rtemp=Math.round((ragree-rdisagree)/responses*100);
			ctemp=Math.round((cagree-cdisagree)/responses*100);
			brk=Math.round((htemp+rtemp+ctemp+ttemp)/4);
			surveyed=Math.round(responses/respondents*100);
			items.push({"column":obj2, "breakout":brk,"surveyed":surveyed});
			
		});
		this.current_demo=items;
		//console.log('demo',items);
	}
	selectIndustryNew(){
		this.setSectorsNew();
		this.current_scores=this.generateBenchmarksNew();
		this.industry_scores=this.generateBestScoresNew();
		this.current_behaviors=this.generateBehaviorsNew();
		this.current_attributes=this.generateAttributesNew();
		this.generateMarketCap();
		this.selectDemoNew();
	}
	setSectorsNew(){
		var items=[];
		var that=this;
		//this.clearCalcScores();
		this.trust_data.forEach(function(obj){
		  if(that.current_industries.findIndex((element) => element == obj.industry)>-1){
			  if(items.indexOf(obj.brands_grouping)<0){
				  items.push(obj.brands_grouping);
			  }
		  }
	  });
		this.sectors=items;
		//console.log('sectors',items);
	}
	setCategoriesNew(){
		this.category="";
		this.clearCalcScores();
		var that=this;

		if(this.current_sectors.length>0){
			var items=[];
			////console.log('sect',sector);
			this.trust_data.forEach(function(obj){
				if(that.current_sectors.findIndex((element) => element == obj.brands_grouping)>-1){
					if(items.indexOf(obj.brands_category)<0){
					  items.push(obj.brands_category);
					}
				}
		  	});
			this.categories=items;
			this.sector_scores=this.generateBenchmarksNew();
			this.current_behaviors=this.generateBehaviorsNew();
			this.current_scores=this.sector_scores;
			this.current_attributes=this.generateAttributesNew();
		 }else{
			 this.sector_scores={composite:0,transparency:0,reliability:0,capability:0,humanity:0,responses:0,ta:0,td:0,ra:0,rd:0,ca:0,cd:0,ha:0,hd:0,xa:0,xd:0,offset_x:0,offset_t:0,offset_r:0,offset_c:0,offset_h:0};
			 this.sector_visible=false;
			 this.current_scores=this.generateBenchmarksNew();
			 this.current_behaviors=this.generateBehaviorsNew();
			 this.current_attributes=this.generateAttributesNew();
		 }
		
	  	this.generateMarketCap();
		this.selectDemoNew();
		////console.log(this.categories);
	}
	setCategoryScoresNew(){
		this.clearCalcScores();
		this.current_scores=this.generateBenchmarksNew();
		this.current_behaviors=this.generateBehaviorsNew();			
	  	this.generateMarketCap();
		this.selectDemoNew();
	}
	
	generateBestScoresNew(){
		this.clearBestCalcScores();
		var temp=[];
		var best=[];
		var test=[];
		var arr=this.temp_arr;
		var that=this;
		console.log('beststarting',this.best_data);
		this.best_data.forEach(function(obj){			
			if(that.current_industries.length>0){
				if(that.current_industries.findIndex((element) => element == obj.industry)>-1){
				/*	that.temp_arr=that.calculateArr(that.temp_arr,obj);
					//console.log('testis',that.temp_arr);
					obj.transparency=Math.round((that.temp_arr.ta-that.temp_arr.td)/that.temp_arr.responses*100);
					obj.reliability=Math.round((that.temp_arr.ra-that.temp_arr.rd)/that.temp_arr.responses*100);
					obj.capability=Math.round((that.temp_arr.ca-that.temp_arr.cd)/that.temp_arr.responses*100);
					obj.humanity=Math.round((that.temp_arr.ha-that.temp_arr.hd)/that.temp_arr.responses*100);
					obj.composite=Math.round((obj.transparency + obj.reliability+obj.capability+obj.humanity)/4);
					*/
					temp.push(obj);
					//arr=that.calculateArr(arr,obj);
					//this.clearBestCalcScores();
		
				}
			}else{
				/*
				obj.transparency=Number((obj.TransparencyAgree-obj.TransparencyAgree)/obj.responses*100);
					that.temp_arr=that.calculateArr(that.temp_arr,obj);
					//console.log('testis',that.temp_arr);
					obj.transparency=Math.round((that.temp_arr.ta-that.temp_arr.td)/that.temp_arr.responses*100);
					obj.reliability=Math.round((that.temp_arr.ra-that.temp_arr.rd)/that.temp_arr.responses*100);
					obj.capability=Math.round((that.temp_arr.ca-that.temp_arr.cd)/that.temp_arr.responses*100);
					obj.humanity=Math.round((that.temp_arr.ha-that.temp_arr.hd)/that.temp_arr.responses*100);
					obj.composite=Math.round((obj.transparency + obj.reliability+obj.capability+obj.humanity)/4);
					*/
					temp.push(obj);
				//this.clearBestCalcScores();
		
				//arr=that.calculateArr(arr,obj);
				////console.log('default');
			}
		})
		console.log('mk1',temp);
		temp=temp.sort((a, b) => b.composite - a.composite);
		this.result_arr.composite=temp[0].composite;
		console.log('mkx',temp[0]);
		temp=temp.sort((a, b) => b.transparency - a.transparency);
		this.result_arr.transparency=temp[0].transparency;
		console.log('mkt',temp[0]);
		temp=temp.sort((a, b) => b.reliability - a.reliability);
		this.result_arr.reliability=temp[0].reliability;
		console.log('mkr',temp[0]);
		temp=temp.sort((a, b) => b.capability - a.capability);
		this.result_arr.capability=temp[0].capability;
		console.log('mkc',temp[0]);
		temp=temp.sort((a, b) => b.humanity - a.humanity);
		this.result_arr.humanity=temp[0].humanity;
		console.log('mkh',temp[0]);
		
//		console.log('MKbestis', temp);
		console.log('MKresult', this.result_arr);
		//temp.forEach(function(obj){
			//arr=that.calculateArr(arr,temp[0]);
		//});
		
		//myArray.sort((a, b) => a.distance - b.distance)
	//	this.result_arr.transparency=Math.round((arr.ta-arr.td)/arr.responses*100);
	//	this.result_arr.reliability=Math.round((arr.ra-arr.rd)/arr.responses*100);
	//	this.result_arr.capability=Math.round((arr.ca-arr.cd)/arr.responses*100);
	//	this.result_arr.humanity=Math.round((arr.ha-arr.hd)/arr.responses*100);
		//this.result_arr.composite=Math.round((arr.xa-arr.xd)/arr.responses*100);
	//	this.result_arr.composite=Math.round((this.result_arr.transparency + this.result_arr.reliability+this.result_arr.capability+this.result_arr.humanity)/4);
	/*	this.result_arr.ta=Math.round(arr.ta/arr.responses*100);
		this.result_arr.td=Math.round(arr.td/arr.responses*100);
		this.result_arr.ra=Math.round(arr.ra/arr.responses*100);
		this.result_arr.rd=Math.round(arr.rd/arr.responses*100);
		this.result_arr.ca=Math.round(arr.ca/arr.responses*100);
		this.result_arr.cd=Math.round(arr.cd/arr.responses*100);
		this.result_arr.ha=Math.round(arr.ha/arr.responses*100);
		this.result_arr.hd=Math.round(arr.hd/arr.responses*100);
		this.result_arr.xa=Math.round(arr.xa/arr.responses*100);
		this.result_arr.xd=Math.round(arr.xd/arr.responses*100);
		this.result_arr.responses=arr.responses;
	*/	
		//this.result_arr.composite=Math.round((this.result_arr.transparency+this.result_arr.reliability+this.result_arr.capability+this.result_arr.humanity)/4);
		//if(filter=="category"){
		this.result_arr.offset_t=this.animateCircle(this.result_arr.transparency);
		this.result_arr.offset_r=this.animateCircle(this.result_arr.reliability);
		this.result_arr.offset_c=this.animateCircle(this.result_arr.capability);
		this.result_arr.offset_h=this.animateCircle(this.result_arr.humanity);
		this.result_arr.offset_x=this.animateCircle(this.result_arr.composite);
		//}
		
		//.log( 'arr3',arr);
		////console.log('industry',this.industry_scores);
		////console.log('sector',this.sector_scores);
		//console.log( 'resultarr',this.result_arr);
		
		return this.result_arr;
		
	}
	
	generateBenchmarksNew(){
		this.clearCalcScores();
		var arr=this.temp_arr;
		var that=this;
		//console.log('starting',this.trust_data);
		this.trust_data.forEach(function(obj){			
			if(that.current_categories.length>0){
				
				if(that.current_categories.findIndex((element) => element == obj.brands_category)>-1){
					arr=that.calculateArr(arr,obj);
				}
			}else if(that.current_sectors.length>0){
				if(that.current_sectors.findIndex((element) => element == obj.brands_grouping)>-1){
					arr=that.calculateArr(arr,obj);
				}
			}else if(that.current_industries.length>0){
				if(that.current_industries.findIndex((element) => element == obj.industry)>-1){
					arr=that.calculateArr(arr,obj);
				}
			}else{
				arr=that.calculateArr(arr,obj);
				//console.log('default');
			}
		})
		this.result_arr.transparency=Math.round((arr.ta-arr.td)/arr.responses*100);
		this.result_arr.reliability=Math.round((arr.ra-arr.rd)/arr.responses*100);
		this.result_arr.capability=Math.round((arr.ca-arr.cd)/arr.responses*100);
		this.result_arr.humanity=Math.round((arr.ha-arr.hd)/arr.responses*100);
		this.result_arr.composite=Math.round((this.result_arr.transparency + this.result_arr.reliability+this.result_arr.capability+this.result_arr.humanity)/4);
		this.result_arr.ta=Math.round(arr.ta/arr.responses*100);
		this.result_arr.td=Math.round(arr.td/arr.responses*100);
		this.result_arr.ra=Math.round(arr.ra/arr.responses*100);
		this.result_arr.rd=Math.round(arr.rd/arr.responses*100);
		this.result_arr.ca=Math.round(arr.ca/arr.responses*100);
		this.result_arr.cd=Math.round(arr.cd/arr.responses*100);
		this.result_arr.ha=Math.round(arr.ha/arr.responses*100);
		this.result_arr.hd=Math.round(arr.hd/arr.responses*100);
		this.result_arr.xa=Math.round(arr.xa/arr.responses*100);
		this.result_arr.xd=Math.round(arr.xd/arr.responses*100);
		this.result_arr.responses=arr.responses;
		
		//this.result_arr.composite=Math.round((this.result_arr.transparency+this.result_arr.reliability+this.result_arr.capability+this.result_arr.humanity)/4);
		//if(filter=="category"){
		this.result_arr.offset_t=this.animateCircle(this.result_arr.transparency);
		this.result_arr.offset_r=this.animateCircle(this.result_arr.reliability);
		this.result_arr.offset_c=this.animateCircle(this.result_arr.capability);
		this.result_arr.offset_h=this.animateCircle(this.result_arr.humanity);
		this.result_arr.offset_x=this.animateCircle(this.result_arr.composite);
		//}
		
		//console.log( 'arr4',arr);
		////console.log('industry',this.industry_scores);
		////console.log('sector',this.sector_scores);
		//console.log( 'resultarr4',this.result_arr);
		
		return this.result_arr;
		
	}
		
	generateAttributesNew(){
		var arr=[];
		var that=this;
		
		this.attr_data.forEach(function(obj){	
			if(that.current_sectors.length>0){
				if(that.current_sectors.findIndex((element) => element == obj.brands_category)>-1){
					arr.push({ factor:obj.factor, attribute: obj.attribute, score:obj.score, responses: obj.responses});
				}
			}else if(that.current_industries.length>0){
				if((that.current_industries.findIndex((element) => element == obj.industry)>-1)&&(that.current_industries.findIndex((element) => element == obj.brands_category)>-1)){
					arr.push({ factor:obj.factor, attribute: obj.attribute, score:obj.score, responses: obj.responses});
				}
			}
		});
		arr.sort((a, b) => {return b.score - a.score;});
		//console.log('result', arr);
		return arr;
	}
	
	generateBehaviorsNew(){
		var arr=this.CS.processBehaviors(this.behavior_data);
		var that=this;
		
		if(this.current_industries.length>0){
			let property: keyof typeof arr; // Type is 'foo' | 'bar'
			for (property in arr) {
				arr[property]=0;
			}
			
			this.behavior_data.forEach(function(obj,value){

				if(that.current_categories.length>0){
					if(that.current_categories.findIndex((element) => element == obj.brands_category)>-1){
						arr=that.calculateArrBehavior(arr,obj);
					}
				}else if(that.current_sectors.length>0){
					if(that.current_sectors.findIndex((element) => element == obj.brands_grouping)>-1){
						arr=that.calculateArrBehavior(arr,obj);
					}
				}else if(that.current_industries.length>0){
					if(that.current_industries.findIndex((element) => element == obj.industry)>-1){
						arr=that.calculateArrBehavior(arr,obj);
					}
				}else{
					arr=that.calculateArrBehavior(arr,obj);
					//console.log('default');
				}
			})
		}

		
		//console.log( 'bhaviors',arr);
		
		return arr;
		
	}

	
	generateBenchmarks(filter){
		this.clearCalcScores();
		var arr=this.temp_arr;
		var that=this;
		//console.log('starting',this.trust_data);
		this.trust_data.forEach(function(obj){
			if(filter=='industry' && that.industry==''){
				
				arr.responses+=Number(obj.responses);
				arr.hd+=Number(obj.HumanityDisagree);
				arr.ha+=Number(obj.HumanityAgree);
				arr.td+=Number(obj.TransparencyDisagree);
				arr.ta+=Number(obj.TransparencyAgree);
				arr.cd+=Number(obj.CapabilityDisagree);
				arr.ca+=Number(obj.CapabilityAgree);
				arr.rd+=Number(obj.ReliabilityDisagree);
				arr.ra+=Number(obj.ReliabilityAgree);
				arr.xd+=Number(obj.CompositeDisagree);
				arr.xa+=Number(obj.CompositeAgree);
			}
			else if(filter=='industry'){
				if(obj.industry==that.industry){
					arr.responses+=Number(obj.responses);
					arr.hd+=Number(obj.HumanityDisagree);
					arr.ha+=Number(obj.HumanityAgree);
					arr.td+=Number(obj.TransparencyDisagree);
					arr.ta+=Number(obj.TransparencyAgree);
					arr.cd+=Number(obj.CapabilityDisagree);
					arr.ca+=Number(obj.CapabilityAgree);
					arr.rd+=Number(obj.ReliabilityDisagree);
					arr.ra+=Number(obj.ReliabilityAgree);
					arr.xd+=Number(obj.CompositeDisagree);
					arr.xa+=Number(obj.CompositeAgree);
				}
			}
			else if(filter=='sector'){
				if(obj.industry==that.industry && obj.brands_grouping==that.sector){
					arr.responses+=Number(obj.responses);
					arr.hd+=Number(obj.HumanityDisagree);
					arr.ha+=Number(obj.HumanityAgree);
					arr.td+=Number(obj.TransparencyDisagree);
					arr.ta+=Number(obj.TransparencyAgree);
					arr.cd+=Number(obj.CapabilityDisagree);
					arr.ca+=Number(obj.CapabilityAgree);
					arr.rd+=Number(obj.ReliabilityDisagree);
					arr.ra+=Number(obj.ReliabilityAgree);
					arr.xd+=Number(obj.CompositeDisagree);
					arr.xa+=Number(obj.CompositeAgree);
				}
			}
			else if(filter=="category"){
				if(obj.industry==that.industry && obj.brands_grouping==that.sector && obj.brands_category==that.category ){
					arr.responses+=Number(obj.responses);
					arr.hd+=Number(obj.HumanityDisagree);
					arr.ha+=Number(obj.HumanityAgree);
					arr.td+=Number(obj.TransparencyDisagree);
					arr.ta+=Number(obj.TransparencyAgree);
					arr.cd+=Number(obj.CapabilityDisagree);
					arr.ca+=Number(obj.CapabilityAgree);
					arr.rd+=Number(obj.ReliabilityDisagree);
					arr.ra+=Number(obj.ReliabilityAgree);
					arr.xd+=Number(obj.CompositeDisagree);
					arr.xa+=Number(obj.CompositeAgree);
				}
				
			}		
		})
		this.result_arr.transparency=Math.round((arr.ta-arr.td)/arr.responses*100);
		this.result_arr.reliability=Math.round((arr.ra-arr.rd)/arr.responses*100);
		this.result_arr.capability=Math.round((arr.ca-arr.cd)/arr.responses*100);
		this.result_arr.humanity=Math.round((arr.ha-arr.hd)/arr.responses*100);
		this.result_arr.ta=Math.round(arr.ta/arr.responses*100);
		this.result_arr.td=Math.round(arr.td/arr.responses*100);
		this.result_arr.ra=Math.round(arr.ra/arr.responses*100);
		this.result_arr.rd=Math.round(arr.rd/arr.responses*100);
		this.result_arr.ca=Math.round(arr.ca/arr.responses*100);
		this.result_arr.cd=Math.round(arr.cd/arr.responses*100);
		this.result_arr.ha=Math.round(arr.ha/arr.responses*100);
		this.result_arr.hd=Math.round(arr.hd/arr.responses*100);
		this.result_arr.responses=arr.responses;
		
		this.result_arr.composite=Math.round((this.result_arr.transparency+this.result_arr.reliability+this.result_arr.capability+this.result_arr.humanity)/4);
		//if(filter=="category"){
		this.result_arr.offset_t=this.animateCircle(this.result_arr.transparency);
		this.result_arr.offset_r=this.animateCircle(this.result_arr.reliability);
		this.result_arr.offset_c=this.animateCircle(this.result_arr.capability);
		this.result_arr.offset_h=this.animateCircle(this.result_arr.humanity);
		this.result_arr.offset_x=this.animateCircle(this.result_arr.composite);
		//}
		
		//console.log( 'arr3',arr);
		////console.log('industry',this.industry_scores);
		////console.log('sector',this.sector_scores);
		//console.log( 'resultarr',this.result_arr);
		
		return this.result_arr;
		
	}
	generateAttributes(filter){
		var arr=[];
		var that=this;
		
		this.attr_data.forEach(function(obj){	
			if(filter=='industry'){
				if(obj.industry==that.industry && obj.brands_category==that.industry){
					arr.push({ factor:obj.factor, attribute: obj.attribute, score:obj.score, responses: obj.responses});
				}
			}else if(filter=='sector'){
				if(obj.industry==that.industry && obj.brands_category==that.sector){	
					arr.push({ factor:obj.factor, attribute: obj.attribute, score:obj.score,responses: obj.responses});
				}
			}
		});
		arr.sort((a, b) => {return b.score - a.score;});
		//console.log('result', arr);
		return arr;
	}
	generateBehaviors(filter){
	//	this.clearCalcScores();
		//var arr=this.CS.totalObj[0];
		var arr=this.CS.processBehaviors(this.behavior_data);
		var that=this;
		
		if(this.industry!==''){
			let property: keyof typeof arr; // Type is 'foo' | 'bar'
			for (property in arr) {
				arr[property]=0;
			}
			
			this.behavior_data.forEach(function(obj,value){
////console.log('obj', obj);
				if(filter=='industry'){
					//console.log(that.sector);
					if(obj.industry=that.industry){
						//console.log('got',obj.brands_grouping );
arr.PurchResponse+=Number(obj.PurchResponse);
arr.PurchStrongResponse+=Number(obj.PurchStrongResponse);
arr.AdvResponse+=Number(obj.AdvResponse);
arr.AdvStrongResponse+=Number(obj.AdvStrongResponse);
arr.ServiceResponse+=Number(obj.ServiceResponse);
arr.ServiceStrongResponse+=Number(obj.ServiceStrongResponse);
arr.PurchHumanityDisagree+=Number(obj.PurchHumanityDisagree);
arr.PurchHumanityAgree+=Number(obj.PurchHumanityAgree);
arr.PurchTransparencyDisagree+=Number(obj.PurchTransparencyDisagree);
arr.PurchTransparencyAgree+=Number(obj.PurchTransparencyAgree);
arr.PurchCapabilityDisagree+=Number(obj.PurchCapabilityDisagree);
arr.PurchCapabilityAgree+=Number(obj.PurchCapabilityAgree);
arr.PurchReliabilityDisagree+=Number(obj.PurchReliabilityDisagree);
arr.PurchReliabilityAgree+=Number(obj.PurchReliabilityAgree);
arr.PurchCompositeDisagree+=Number(obj.PurchCompositeDisagree);
arr.PurchCompositeAgree+=Number(obj.PurchCompositeAgree);
arr.PurchStrongHumanityDisagree+=Number(obj.PurchStrongHumanityDisagree);
arr.PurchStrongHumanityAgree+=Number(obj.PurchStrongHumanityAgree);
arr.PurchStrongTransparencyDisagree+=Number(obj.PurchStrongTransparencyDisagree);
arr.PurchStrongTransparencyAgree+=Number(obj.PurchStrongTransparencyAgree);
arr.PurchStrongCapabilityDisagree+=Number(obj.PurchStrongCapabilityDisagree);
arr.PurchStrongCapabilityAgree+=Number(obj.PurchStrongCapabilityAgree);
arr.PurchStrongReliabilityDisagree+=Number(obj.PurchStrongReliabilityDisagree);
arr.PurchStrongReliabilityAgree+=Number(obj.PurchStrongReliabilityAgree);
arr.PurchStrongCompositeDisagree+=Number(obj.PurchStrongCompositeDisagree);
arr.PurchStrongCompositeAgree+=Number(obj.PurchStrongCompositeAgree);
arr.AdvHumanityDisagree+=Number(obj.AdvHumanityDisagree);
arr.AdvHumanityAgree+=Number(obj.AdvHumanityAgree);
arr.AdvTransparencyDisagree+=Number(obj.AdvTransparencyDisagree);
arr.AdvTransparencyAgree+=Number(obj.AdvTransparencyAgree);
arr.AdvCapabilityDisagree+=Number(obj.AdvCapabilityDisagree);
arr.AdvCapabilityAgree+=Number(obj.AdvCapabilityAgree);
arr.AdvReliabilityDisagree+=Number(obj.AdvReliabilityDisagree);
arr.AdvReliabilityAgree+=Number(obj.AdvReliabilityAgree);
arr.AdvCompositeDisagree+=Number(obj.AdvCompositeDisagree);
arr.AdvCompositeAgree+=Number(obj.AdvCompositeAgree);
arr.AdvStrongHumanityDisagree+=Number(obj.AdvStrongHumanityDisagree);
arr.AdvStrongHumanityAgree+=Number(obj.AdvStrongHumanityAgree);
arr.AdvStrongTransparencyDisagree+=Number(obj.AdvStrongTransparencyDisagree);
arr.AdvStrongTransparencyAgree+=Number(obj.AdvStrongTransparencyAgree);
arr.AdvStrongCapabilityDisagree+=Number(obj.AdvStrongCapabilityDisagree);
arr.AdvStrongCapabilityAgree+=Number(obj.AdvStrongCapabilityAgree);
arr.AdvStrongReliabilityDisagree+=Number(obj.AdvStrongReliabilityDisagree);
arr.AdvStrongReliabilityAgree+=Number(obj.AdvStrongReliabilityAgree);
arr.AdvStrongCompositeDisagree+=Number(obj.AdvStrongCompositeDisagree);
arr.AdvStrongCompositeAgree+=Number(obj.AdvStrongCompositeAgree);
arr.ServiceHumanityDisagree+=Number(obj.ServiceHumanityDisagree);
arr.ServiceHumanityAgree+=Number(obj.ServiceHumanityAgree);
arr.ServiceTransparencyDisagree+=Number(obj.ServiceTransparencyDisagree);
arr.ServiceTransparencyAgree+=Number(obj.ServiceTransparencyAgree);
arr.ServiceCapabilityDisagree+=Number(obj.ServiceCapabilityDisagree);
arr.ServiceCapabilityAgree+=Number(obj.ServiceCapabilityAgree);
arr.ServiceReliabilityDisagree+=Number(obj.ServiceReliabilityDisagree);
arr.ServiceReliabilityAgree+=Number(obj.ServiceReliabilityAgree);
arr.ServiceCompositeDisagree+=Number(obj.ServiceCompositeDisagree);
arr.ServiceCompositeAgree+=Number(obj.ServiceCompositeAgree);
arr.ServiceStrongHumanityDisagree+=Number(obj.ServiceStrongHumanityDisagree);
arr.ServiceStrongHumanityAgree+=Number(obj.ServiceStrongHumanityAgree);
arr.ServiceStrongTransparencyDisagree+=Number(obj.ServiceStrongTransparencyDisagree);
arr.ServiceStrongTransparencyAgree+=Number(obj.ServiceStrongTransparencyAgree);
arr.ServiceStrongCapabilityDisagree+=Number(obj.ServiceStrongCapabilityDisagree);
arr.ServiceStrongCapabilityAgree+=Number(obj.ServiceStrongCapabilityAgree);
arr.ServiceStrongReliabilityDisagree+=Number(obj.ServiceStrongReliabilityDisagree);
arr.ServiceStrongReliabilityAgree+=Number(obj.ServiceStrongReliabilityAgree);
arr.ServiceStrongCompositeDisagree+=Number(obj.ServiceStrongCompositeDisagree);
arr.ServiceStrongCompositeAgree+=Number(obj.ServiceStrongCompositeAgree);

					}
				}
				else if(filter=='sector'){
					//console.log(that.sector);
					if(obj.brands_grouping==that.sector && obj.industry==that.industry){
						//console.log('got',obj.brands_grouping );
arr.PurchResponse=arr.PurchResponse+obj.PurchResponse;
arr.PurchStrongResponse=arr.PurchStrongResponse+obj.PurchStrongResponse;
arr.AdvResponse=arr.AdvResponse+obj.AdvResponse;
arr.AdvStrongResponse=arr.AdvStrongResponse+obj.AdvStrongResponse;
arr.ServiceResponse=arr.ServiceResponse+obj.ServiceResponse;
arr.ServiceStrongResponse=arr.ServiceStrongResponse+obj.ServiceStrongResponse;
arr.PurchHumanityDisagree=arr.PurchHumanityDisagree+obj.PurchHumanityDisagree;
arr.PurchHumanityAgree=arr.PurchHumanityAgree+obj.PurchHumanityAgree;
arr.PurchTransparencyDisagree=arr.PurchTransparencyDisagree+obj.PurchTransparencyDisagree;
arr.PurchTransparencyAgree=arr.PurchTransparencyAgree+obj.PurchTransparencyAgree;
arr.PurchCapabilityDisagree=arr.PurchCapabilityDisagree+obj.PurchCapabilityDisagree;
arr.PurchCapabilityAgree=arr.PurchCapabilityAgree+obj.PurchCapabilityAgree;
arr.PurchReliabilityDisagree=arr.PurchReliabilityDisagree+obj.PurchReliabilityDisagree;
arr.PurchReliabilityAgree=arr.PurchReliabilityAgree+obj.PurchReliabilityAgree;
arr.PurchCompositeDisagree=arr.PurchCompositeDisagree+obj.PurchCompositeDisagree;
arr.PurchCompositeAgree=arr.PurchCompositeAgree+obj.PurchCompositeAgree;
arr.PurchStrongHumanityDisagree=arr.PurchStrongHumanityDisagree+obj.PurchStrongHumanityDisagree;
arr.PurchStrongHumanityAgree=arr.PurchStrongHumanityAgree+obj.PurchStrongHumanityAgree;
arr.PurchStrongTransparencyDisagree=arr.PurchStrongTransparencyDisagree+obj.PurchStrongTransparencyDisagree;
arr.PurchStrongTransparencyAgree=arr.PurchStrongTransparencyAgree+obj.PurchStrongTransparencyAgree;
arr.PurchStrongCapabilityDisagree=arr.PurchStrongCapabilityDisagree+obj.PurchStrongCapabilityDisagree;
arr.PurchStrongCapabilityAgree=arr.PurchStrongCapabilityAgree+obj.PurchStrongCapabilityAgree;
arr.PurchStrongReliabilityDisagree=arr.PurchStrongReliabilityDisagree+obj.PurchStrongReliabilityDisagree;
arr.PurchStrongReliabilityAgree=arr.PurchStrongReliabilityAgree+obj.PurchStrongReliabilityAgree;
arr.PurchStrongCompositeDisagree=arr.PurchStrongCompositeDisagree+obj.PurchStrongCompositeDisagree;
arr.PurchStrongCompositeAgree=arr.PurchStrongCompositeAgree+obj.PurchStrongCompositeAgree;
arr.AdvHumanityDisagree=arr.AdvHumanityDisagree+obj.AdvHumanityDisagree;
arr.AdvHumanityAgree=arr.AdvHumanityAgree+obj.AdvHumanityAgree;
arr.AdvTransparencyDisagree=arr.AdvTransparencyDisagree+obj.AdvTransparencyDisagree;
arr.AdvTransparencyAgree=arr.AdvTransparencyAgree+obj.AdvTransparencyAgree;
arr.AdvCapabilityDisagree=arr.AdvCapabilityDisagree+obj.AdvCapabilityDisagree;
arr.AdvCapabilityAgree=arr.AdvCapabilityAgree+obj.AdvCapabilityAgree;
arr.AdvReliabilityDisagree=arr.AdvReliabilityDisagree+obj.AdvReliabilityDisagree;
arr.AdvReliabilityAgree=arr.AdvReliabilityAgree+obj.AdvReliabilityAgree;
arr.AdvCompositeDisagree=arr.AdvCompositeDisagree+obj.AdvCompositeDisagree;
arr.AdvCompositeAgree=arr.AdvCompositeAgree+obj.AdvCompositeAgree;
arr.AdvStrongHumanityDisagree=arr.AdvStrongHumanityDisagree+obj.AdvStrongHumanityDisagree;
arr.AdvStrongHumanityAgree=arr.AdvStrongHumanityAgree+obj.AdvStrongHumanityAgree;
arr.AdvStrongTransparencyDisagree=arr.AdvStrongTransparencyDisagree+obj.AdvStrongTransparencyDisagree;
arr.AdvStrongTransparencyAgree=arr.AdvStrongTransparencyAgree+obj.AdvStrongTransparencyAgree;
arr.AdvStrongCapabilityDisagree=arr.AdvStrongCapabilityDisagree+obj.AdvStrongCapabilityDisagree;
arr.AdvStrongCapabilityAgree=arr.AdvStrongCapabilityAgree+obj.AdvStrongCapabilityAgree;
arr.AdvStrongReliabilityDisagree=arr.AdvStrongReliabilityDisagree+obj.AdvStrongReliabilityDisagree;
arr.AdvStrongReliabilityAgree=arr.AdvStrongReliabilityAgree+obj.AdvStrongReliabilityAgree;
arr.AdvStrongCompositeDisagree=arr.AdvStrongCompositeDisagree+obj.AdvStrongCompositeDisagree;
arr.AdvStrongCompositeAgree=arr.AdvStrongCompositeAgree+obj.AdvStrongCompositeAgree;
arr.ServiceHumanityDisagree=arr.ServiceHumanityDisagree+obj.ServiceHumanityDisagree;
arr.ServiceHumanityAgree=arr.ServiceHumanityAgree+obj.ServiceHumanityAgree;
arr.ServiceTransparencyDisagree=arr.ServiceTransparencyDisagree+obj.ServiceTransparencyDisagree;
arr.ServiceTransparencyAgree=arr.ServiceTransparencyAgree+obj.ServiceTransparencyAgree;
arr.ServiceCapabilityDisagree=arr.ServiceCapabilityDisagree+obj.ServiceCapabilityDisagree;
arr.ServiceCapabilityAgree=arr.ServiceCapabilityAgree+obj.ServiceCapabilityAgree;
arr.ServiceReliabilityDisagree=arr.ServiceReliabilityDisagree+obj.ServiceReliabilityDisagree;
arr.ServiceReliabilityAgree=arr.ServiceReliabilityAgree+obj.ServiceReliabilityAgree;
arr.ServiceCompositeDisagree=arr.ServiceCompositeDisagree+obj.ServiceCompositeDisagree;
arr.ServiceCompositeAgree=arr.ServiceCompositeAgree+obj.ServiceCompositeAgree;
arr.ServiceStrongHumanityDisagree=arr.ServiceStrongHumanityDisagree+obj.ServiceStrongHumanityDisagree;
arr.ServiceStrongHumanityAgree=arr.ServiceStrongHumanityAgree+obj.ServiceStrongHumanityAgree;
arr.ServiceStrongTransparencyDisagree=arr.ServiceStrongTransparencyDisagree+obj.ServiceStrongTransparencyDisagree;
arr.ServiceStrongTransparencyAgree=arr.ServiceStrongTransparencyAgree+obj.ServiceStrongTransparencyAgree;
arr.ServiceStrongCapabilityDisagree=arr.ServiceStrongCapabilityDisagree+obj.ServiceStrongCapabilityDisagree;
arr.ServiceStrongCapabilityAgree=arr.ServiceStrongCapabilityAgree+obj.ServiceStrongCapabilityAgree;
arr.ServiceStrongReliabilityDisagree=arr.ServiceStrongReliabilityDisagree+obj.ServiceStrongReliabilityDisagree;
arr.ServiceStrongReliabilityAgree=arr.ServiceStrongReliabilityAgree+obj.ServiceStrongReliabilityAgree;
arr.ServiceStrongCompositeDisagree=arr.ServiceStrongCompositeDisagree+obj.ServiceStrongCompositeDisagree;
arr.ServiceStrongCompositeAgree=arr.ServiceStrongCompositeAgree+obj.ServiceStrongCompositeAgree;

					}
				}
				else if(filter=="category"){
					if(obj.brands_grouping==that.sector && obj.brands_category==that.category && obj.industry==that.industry ){
arr.PurchResponse=arr.PurchResponse+obj.PurchResponse;
arr.PurchStrongResponse=arr.PurchStrongResponse+obj.PurchStrongResponse;
arr.AdvResponse=arr.AdvResponse+obj.AdvResponse;
arr.AdvStrongResponse=arr.AdvStrongResponse+obj.AdvStrongResponse;
arr.ServiceResponse=arr.ServiceResponse+obj.ServiceResponse;
arr.ServiceStrongResponse=arr.ServiceStrongResponse+obj.ServiceStrongResponse;
arr.PurchHumanityDisagree=arr.PurchHumanityDisagree+obj.PurchHumanityDisagree;
arr.PurchHumanityAgree=arr.PurchHumanityAgree+obj.PurchHumanityAgree;
arr.PurchTransparencyDisagree=arr.PurchTransparencyDisagree+obj.PurchTransparencyDisagree;
arr.PurchTransparencyAgree=arr.PurchTransparencyAgree+obj.PurchTransparencyAgree;
arr.PurchCapabilityDisagree=arr.PurchCapabilityDisagree+obj.PurchCapabilityDisagree;
arr.PurchCapabilityAgree=arr.PurchCapabilityAgree+obj.PurchCapabilityAgree;
arr.PurchReliabilityDisagree=arr.PurchReliabilityDisagree+obj.PurchReliabilityDisagree;
arr.PurchReliabilityAgree=arr.PurchReliabilityAgree+obj.PurchReliabilityAgree;
arr.PurchCompositeDisagree=arr.PurchCompositeDisagree+obj.PurchCompositeDisagree;
arr.PurchCompositeAgree=arr.PurchCompositeAgree+obj.PurchCompositeAgree;
arr.PurchStrongHumanityDisagree=arr.PurchStrongHumanityDisagree+obj.PurchStrongHumanityDisagree;
arr.PurchStrongHumanityAgree=arr.PurchStrongHumanityAgree+obj.PurchStrongHumanityAgree;
arr.PurchStrongTransparencyDisagree=arr.PurchStrongTransparencyDisagree+obj.PurchStrongTransparencyDisagree;
arr.PurchStrongTransparencyAgree=arr.PurchStrongTransparencyAgree+obj.PurchStrongTransparencyAgree;
arr.PurchStrongCapabilityDisagree=arr.PurchStrongCapabilityDisagree+obj.PurchStrongCapabilityDisagree;
arr.PurchStrongCapabilityAgree=arr.PurchStrongCapabilityAgree+obj.PurchStrongCapabilityAgree;
arr.PurchStrongReliabilityDisagree=arr.PurchStrongReliabilityDisagree+obj.PurchStrongReliabilityDisagree;
arr.PurchStrongReliabilityAgree=arr.PurchStrongReliabilityAgree+obj.PurchStrongReliabilityAgree;
arr.PurchStrongCompositeDisagree=arr.PurchStrongCompositeDisagree+obj.PurchStrongCompositeDisagree;
arr.PurchStrongCompositeAgree=arr.PurchStrongCompositeAgree+obj.PurchStrongCompositeAgree;
arr.AdvHumanityDisagree=arr.AdvHumanityDisagree+obj.AdvHumanityDisagree;
arr.AdvHumanityAgree=arr.AdvHumanityAgree+obj.AdvHumanityAgree;
arr.AdvTransparencyDisagree=arr.AdvTransparencyDisagree+obj.AdvTransparencyDisagree;
arr.AdvTransparencyAgree=arr.AdvTransparencyAgree+obj.AdvTransparencyAgree;
arr.AdvCapabilityDisagree=arr.AdvCapabilityDisagree+obj.AdvCapabilityDisagree;
arr.AdvCapabilityAgree=arr.AdvCapabilityAgree+obj.AdvCapabilityAgree;
arr.AdvReliabilityDisagree=arr.AdvReliabilityDisagree+obj.AdvReliabilityDisagree;
arr.AdvReliabilityAgree=arr.AdvReliabilityAgree+obj.AdvReliabilityAgree;
arr.AdvCompositeDisagree=arr.AdvCompositeDisagree+obj.AdvCompositeDisagree;
arr.AdvCompositeAgree=arr.AdvCompositeAgree+obj.AdvCompositeAgree;
arr.AdvStrongHumanityDisagree=arr.AdvStrongHumanityDisagree+obj.AdvStrongHumanityDisagree;
arr.AdvStrongHumanityAgree=arr.AdvStrongHumanityAgree+obj.AdvStrongHumanityAgree;
arr.AdvStrongTransparencyDisagree=arr.AdvStrongTransparencyDisagree+obj.AdvStrongTransparencyDisagree;
arr.AdvStrongTransparencyAgree=arr.AdvStrongTransparencyAgree+obj.AdvStrongTransparencyAgree;
arr.AdvStrongCapabilityDisagree=arr.AdvStrongCapabilityDisagree+obj.AdvStrongCapabilityDisagree;
arr.AdvStrongCapabilityAgree=arr.AdvStrongCapabilityAgree+obj.AdvStrongCapabilityAgree;
arr.AdvStrongReliabilityDisagree=arr.AdvStrongReliabilityDisagree+obj.AdvStrongReliabilityDisagree;
arr.AdvStrongReliabilityAgree=arr.AdvStrongReliabilityAgree+obj.AdvStrongReliabilityAgree;
arr.AdvStrongCompositeDisagree=arr.AdvStrongCompositeDisagree+obj.AdvStrongCompositeDisagree;
arr.AdvStrongCompositeAgree=arr.AdvStrongCompositeAgree+obj.AdvStrongCompositeAgree;
arr.ServiceHumanityDisagree=arr.ServiceHumanityDisagree+obj.ServiceHumanityDisagree;
arr.ServiceHumanityAgree=arr.ServiceHumanityAgree+obj.ServiceHumanityAgree;
arr.ServiceTransparencyDisagree=arr.ServiceTransparencyDisagree+obj.ServiceTransparencyDisagree;
arr.ServiceTransparencyAgree=arr.ServiceTransparencyAgree+obj.ServiceTransparencyAgree;
arr.ServiceCapabilityDisagree=arr.ServiceCapabilityDisagree+obj.ServiceCapabilityDisagree;
arr.ServiceCapabilityAgree=arr.ServiceCapabilityAgree+obj.ServiceCapabilityAgree;
arr.ServiceReliabilityDisagree=arr.ServiceReliabilityDisagree+obj.ServiceReliabilityDisagree;
arr.ServiceReliabilityAgree=arr.ServiceReliabilityAgree+obj.ServiceReliabilityAgree;
arr.ServiceCompositeDisagree=arr.ServiceCompositeDisagree+obj.ServiceCompositeDisagree;
arr.ServiceCompositeAgree=arr.ServiceCompositeAgree+obj.ServiceCompositeAgree;
arr.ServiceStrongHumanityDisagree=arr.ServiceStrongHumanityDisagree+obj.ServiceStrongHumanityDisagree;
arr.ServiceStrongHumanityAgree=arr.ServiceStrongHumanityAgree+obj.ServiceStrongHumanityAgree;
arr.ServiceStrongTransparencyDisagree=arr.ServiceStrongTransparencyDisagree+obj.ServiceStrongTransparencyDisagree;
arr.ServiceStrongTransparencyAgree=arr.ServiceStrongTransparencyAgree+obj.ServiceStrongTransparencyAgree;
arr.ServiceStrongCapabilityDisagree=arr.ServiceStrongCapabilityDisagree+obj.ServiceStrongCapabilityDisagree;
arr.ServiceStrongCapabilityAgree=arr.ServiceStrongCapabilityAgree+obj.ServiceStrongCapabilityAgree;
arr.ServiceStrongReliabilityDisagree=arr.ServiceStrongReliabilityDisagree+obj.ServiceStrongReliabilityDisagree;
arr.ServiceStrongReliabilityAgree=arr.ServiceStrongReliabilityAgree+obj.ServiceStrongReliabilityAgree;
arr.ServiceStrongCompositeDisagree=arr.ServiceStrongCompositeDisagree+obj.ServiceStrongCompositeDisagree;
arr.ServiceStrongCompositeAgree=arr.ServiceStrongCompositeAgree+obj.ServiceStrongCompositeAgree;

					}
				}		
			})
		}

		
		//console.log( 'bhaviors',arr);
		
		return arr;
		
	}
	
	
	
	animateCircle(score) {
		var val = (parseInt(score)/2);
		val = val - val*0.195;

		if (isNaN(val)) {val = 50; } 
			var c = Math.PI*(180);

			if (val > 50) { val = 40;}

			var pct = ((100-val)/100)*c;

			//$el.css({ 
			//	strokeDashoffset: pct
			//});
			return pct;
		
	}
	transformAmount(element){
	  this.market_num=element.target.value;
      this.market_str = this.currencyPipe.transform(this.market_num, '$');
      element.target.value = this.market_num;
	  this.generateMarketCap();
  	}
	transformStock(element){
	  this.stock_num=element.target.value/100;
      this.stock_str = element.target.value+'%';
	  this.generateMarketCap();
	}
	keyPressNumbers(event) {
		var charCode = (event.which) ? event.which : event.keyCode;
		// Only Numbers 0-9 and decimal
		if (charCode!==46 && (charCode < 48 || charCode > 57)) {
		  event.preventDefault();
		  return false;
		} else {
		  return true;
		}
	  }
 	ConvertStringToNumber(input: string) {
	 if(!isNaN(Number(input))){
		 var number = Number(input);
	 }else{
		 var number = Number(input.replace(/[^0-9\.]+/g,""));
	 }
    return number;
}
	generateMarketCap(){
		this.market.original=this.market_num*(1+(this.stock_num*1));
		if(this.industry=="Financial Services"){
			this.market.new=this.market_num*(1+(this.stock_num*(1+(this.current_scores.composite*.0055))));
		}else{
			this.market.new=this.market_num*(1+(this.stock_num*(1+(this.current_scores.composite*.001))));
		}
		this.market.increase=this.market.new-this.market.original;
		this.market.incremental=(this.market.new-this.market.original)/this.current_scores.composite;
		this.market.scale_max=Math.ceil((1.45*this.market.new)/6)*6;
		this.market.scale_step=this.market.scale_max/6;

		
	}
	getScales(minRange, maxRange, min, max){
		var scales = [],                  // Prepare some variables
		ranges = maxRange+1 - minRange,   // Amount of elements to be returned.
		range  = (max-min)/ranges;        // Difference between min and max
		for(var i = 0; i < ranges; i++){
			scales.push({
				range: i+minRange,        // Current range number
				min: min + range * i,
				max: min + range * (i+1)
			});
		}
		////console.log(scales);
	}
	scrollPastHeader(){
		//window.scrollTo({top: document.querySelector(".header").offsetHeight,behavior: 'smooth'});    
	}
	scrollTo() {
		this.tabhead.nativeElement.scrollIntoView({behavior: "smooth", block: "start"});
	}
	toggleSelectOpen(el){
	  if(!this['select_open_'+el]){
		  this['select_open_'+el]=true;
	  }else{
		  this['select_open_'+el]=false;
	  }
    }
	removeItem(val,el){
	  const isThere = (element) => element == val; 
      var i = this[el].findIndex(isThere);
      if (i > -1) {
		  this[el].splice(i, 1);
      }
	}
	addItem(val,el){
	  const isThere = (element) => element == val; 
      var i = this[el].findIndex(isThere);
      if (i > -1) {
		  this[el].splice(i, 1);
		  //check value
      } else {
		  this[el].push(val);
      }
		this.resetSelected();
		//console.log('industries',this.current_industries);
		//console.log('sectors',this.current_sectors);
		//console.log('categories',this.current_categories);
		//console.log(this.current_industries.findIndex((element) => element == 'Consumer'));
	  if(el=="current_industries"){
		  this.selectIndustryNew();
	  }else if(el=="current_sectors"){
		  this.setCategoriesNew();
	  }else if(el=="current_categories"){
		  this.setCategoryScoresNew();
	  }
		//add remove industry item populate 
		// (change)="selectIndustry()" update to pull from current industries
		//(change)="setCategories(sector)"
		//(change)="setCategoryScores()"
		//console.log(val);
    }
	includedItem(val,el){
	   const isThere = (element) => element == val; 
	  var i = this[el].findIndex(isThere);
      if (i > -1) {
		  return true;
      }else{
		  return false;
	  }
  	}

}
